import { createContext, useContext, useMemo, useState } from 'react'
import toast from 'react-hot-toast'
import { useGroupBimLink } from './GroupBimLinkContext'
import { useAuth0 } from '@auth0/auth0-react'
import moment from 'moment'
import { checkIformulaIsValid } from '../utils/checkIfFormulaIsValid'

export const ArticuloBimLinkContext = createContext()

export const ArticuloBimLinkProvider = ({ articulo, children }) => {
  const { addArticulo, updateSingleArticulo } = useGroupBimLink()
  const [selectedActividad, setSelectedActividad] = useState(
    articulo?.actividad || null
  )
  const [selectedArticulo, setSelectedArticulo] = useState(
    articulo?.articulo || null
  )
  const [formula, setFormula] = useState(articulo?.formula || null)
  const [descripcion, setDescripcion] = useState(articulo?.descripcion || '')

  const isEditArticuloMode = useMemo(() => !!articulo, [articulo])

  const [hasTouchedFormula, setHasTouchedFormula] = useState(false)

  const handleFormula = e => {
    setFormula(e.target.value)
    setHasTouchedFormula(true)
  }

  const handleDescripcion = value => {
    setDescripcion(value)
  }

  const { user } = useAuth0()

  const createArticulo = () => {
    if (!selectedActividad || !selectedArticulo || !formula)
      return toast.error('Todos los campos tienen que estar rellenos')

    const newArticulo = {
      actividad: selectedActividad,
      articulo: selectedArticulo,
      formula,
      descripcion,
      userId: user.email,
      ultimaVezPor: new Date(),
    }

    isEditArticuloMode
      ? updateSingleArticulo({ ...newArticulo, uuid: articulo.uuid })
      : addArticulo(newArticulo)
  }

  const fechaFormateada = useMemo(() => {
    return articulo?.ultimaVezPor
      ? moment(articulo.ultimaVezPor).format('LLLL')
      : null
  }, [articulo?.ultimaVezPor])

  const isFormulaValid = useMemo(() => {
    return !!formula && checkIformulaIsValid(formula)
  }, [formula])

  const data = {
    isEditArticuloMode,
    selectedActividad,
    setSelectedActividad,
    selectedArticulo,
    setSelectedArticulo,
    formula,
    handleFormula,
    descripcion,
    handleDescripcion,
    createArticulo,
    ultimaVezPor: fechaFormateada,
    userId: articulo?.userId,
    isFormulaValid,
    hasTouchedFormula,
  }

  return (
    <ArticuloBimLinkContext.Provider value={data}>
      {children}
    </ArticuloBimLinkContext.Provider>
  )
}

export const useArticuloBimLink = () => {
  const context = useContext(ArticuloBimLinkContext)
  if (context === undefined) {
    throw new Error(
      'useArticuloBimLink must be used within a ArticuloBimLinkProvider'
    )
  }
  return context
}
